import styled from 'styled-components';

import ButtonBadge from 'components/ButtonBadge';

export const Wrapper = styled.div`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 100vw;
  height: 100vh;

  background-color: white;

  padding: ${({ theme }) => theme.spacings.abs32}px;
`;

export const Close = styled.span`
  position: absolute;
  top: ${({ theme }) => theme.spacings.abs40}px;
  right: ${({ theme }) => theme.spacings.abs40}px;
`;

export const CloseButton = styled(ButtonBadge)`
  ${Close}:hover &:not(:active) {
    background-color: ${({ theme }): string => theme.colors.ctaBlue(-1)};
    color: white;
  }
`;
